<template>

  <v-data-table :headers="columns" :items="items" :loading="loading" :pagination.sync="pagination_" :rows-per-page-items="paginationOptions" :total-items="totalItems" :hide-actions="hidePagination">
    <template slot="items" slot-scope="{ item, index }">
      <td v-for="(c, i) of options.columns" :key="i" v-if="c.display !== false && c.displayable !== false">
        <component v-if="c.displayComponent" :is="c.displayComponent" :value="item[c.value]" :id="c.value ? item[c.value] : undefined" :item="item"></component>
        <template v-else-if="c.displayRender">{{ c.displayRender(item[c.value]) }}</template>
        <template v-else-if="item[c.value] === 0">0</template>
        <template v-else-if="item[c.value] === null">-</template>
        <template v-else>{{ item[c.value] ? item[c.value][c.subvalue] ? item[c.value][c.subvalue] : item[c.value] : '' }}</template>
      </td>
      <td class="actions" v-if="showActions">
        <v-icon v-for="(action, index) of options.itemActions" :key="index" @click="action.onclick(item)" :title="action.title">{{ action.icon }}</v-icon>
        <v-icon v-if="options.editable === true" title="Edit" @click="$emit('edit', index)">mdi-pencil</v-icon>
        <v-icon v-if="options.editable === 'custom'" title="Edit" @click="$emit('customEdit', index)">mdi-pencil</v-icon>
        <ProxyDeleteButton v-if="options.deletable !== false" @click="options.applyDelete(item)"></ProxyDeleteButton>
        <ProxySuspendButton v-if="options.suspendable" @click="options.applySuspend(item)" :text="options.suspendButtonText"/>
      </td>
    </template>
  </v-data-table>

</template>

<script>

import ProxyDeleteButton from './ProxyDeleteButton'
import ProxySuspendButton from './ProxySuspendButton'

export default {
  name: 'ItemTable',
  components: {
    ProxyDeleteButton,
    ProxySuspendButton
  },
  props: {
    options: {
      type: Object,
      default: () => ({})
    },
    items: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object
    },
    paginationOptions: {
      type: Array
    },
    hidePagination: {
      type: Boolean
    }
  },
  data: () => ({
    confirmationDialog: null
  }),
  computed: {
    columns () {
      let columns = []
      if (this.options.columns) {
        columns = this.options.columns.filter(c => c.display !== false && c.displayable !== false)
      }

      let cols = []
      cols.push(...columns.map(c => ({text: c.text, value: c.value, sortable: c.sortable})))
      if (this.showActions) {
        cols.push({text: 'Actions', sortable: false})
      }

      return cols
    },
    showActions () {
      return !this.options.itemActions ||
        this.options.itemActions.length !== 0 ||
        this.options.editable !== false ||
        this.options.deletable !== false
    },
    pagination_: {
      get () {
        return this.pagination
      },
      set (v) {
        this.$emit('update:pagination', v)
      }
    },
    totalItems () {
      return (this.pagination || {}).totalItems
    }
  }
}

</script>

<style lang="scss" scoped>

.actions {
  min-width: 150px;
}

</style>



// WEBPACK FOOTER //
// src/components/common/ItemTable.vue